import React from "react";
import ReactDOM from "react-dom";

import { observer, inject, Provider } from "mobx-react";
import { extendObservable } from 'mobx';

import StoreButton from './StoreButton'
import ProductList from './ProductList'
import NewStoreButton   from './NewStoreButton'
import ListStylePicker   from './ListStylePicker'

import { ReactComponent as Edit } from '../svg/edit.svg';


@inject('core')
@observer
export default class Store extends React.Component {

	constructor(props) {
		super(props)		
		this.editStore = this.editStore.bind(this)
	}

	componentDidMount() {
		const { core } = this.props		
	}

	editStore() {
		const { core, store_id } = this.props
		
		var name = window.prompt('Store Name', core.stores.find(s => s.store_id == store_id).name)
		if ((typeof name !== 'undefined') && (name !== null)) {
			
			if (
				(name == '') && 
				(window.confirm('Really delete the store ' + core.stores.find(s => s.store_id == store_id).name + '? This will also delete all prices associated with it.'))
			) {
				core.action({
					op: 'deleteStore',
					store_id
				})
			}
			else if (name != '') {
				core.action({
					op:'updateStore', 
					store_id, 
					name: name
				})				
			}
		}		
	}	

	render() {
		const { core, store_id } = this.props
		const store = core.stores.find(s => s.store_id == store_id)
		if (!store) return <div>unknown store</div>
		
		var f 
	
		switch(core.ui.shoppingListType) {
			
			case 'shopping-list':
				f = (product) => product.needs
				break;

			case 'missing-prices':
				f = (product) => !product.prices[store_id]
				break;

			case 'strict-shopping':
				f = (product) => {
					if (!product.needs) return false
					
					var min_price = 9999;			
					Object.keys(product.prices).map(key => {
						const price = product.prices[key]
						if (price) min_price = Math.min(min_price, price)
					})
					
					if (product.prices[store_id] == min_price) return true
					
					return false
				}
				break;

			case 'show-all':
				f = () => true
				break;

		}

		return <div>
			<h1>{store.name} <span className="update-button clickable" onClick={this.editStore}><Edit style={{width:'20px'}} /></span></h1>
			<ListStylePicker />
			<ProductList filter={f} mark_uncheap_store_id={store_id} showNeeds={true} showNeedButton={true} />
		</div>
	}

}
